// @flow
import { Provider } from 'react-redux';
import { stylesheet } from 'typestyle';
import classnames from 'classnames';

import EveryPurchase from '@components/productDetail/pageFooter/EveryPurchase';
import GiaDiamond from '@components/productDetail/pageFooter/GiaDiamond';

import css from '@styles/checkout_footer';

import type { RailsContextType } from '@types/misc';

const packageImage = '/images/yui/lumera_package.jpg';

const localCss = stylesheet({
  image: {},
  imageContainer: {
    position: 'absolute',
    top: 25,
    right: 0,

    '@media (max-width: 909px)': {
      display: 'none'
    }
  }
});

function Container ({ children }) {
  return <div className={css.container}>{children}</div>;
}

function Left ({ children }) {
  return <div className={css.left}>{children}</div>;
}

function Right ({ children }) {
  return <div className={css.right}>{children}</div>;
}

export function List ({ children, inline }) {
  return (
    <ul className={classnames(css.list, { [css.inlineList]: inline })}>
      {children}
    </ul>
  );
}

export function Item ({
  children,
  icon,
  noUnderline,
  iconStyles = {},
  style = {}
}) {
  return (
    <li
      className={classnames(css.item, {
        [css.itemWithIcon]: !!icon,
        [css.underlinedItem]: !noUnderline
      })}
      style={style}>
      {icon ? <img src={icon} style={iconStyles} className={css.icon} /> : null}
      {children}
    </li>
  );
}

function Image () {
  return (
    <div className={localCss.imageContainer}>
      <img
        src={packageImage}
        alt="Package sent with order."
        className={`${localCss.image} contents-image`}
      />
    </div>
  );
}

function Footer () {
  return (
    <div className="received-items">
      <Container>
        <Left>
          <EveryPurchase />
        </Left>
        <Right>
          <GiaDiamond />
        </Right>
      </Container>
      <Image />
    </div>
  );
}

export default (props: {}, railsContext: RailsContextType) => {
  const store = ReactOnRails.getStore('SharedReduxStore');

  return (
    <Provider store={store}>
      <Footer {...{ ...props, railsContext }} />
    </Provider>
  );
};
